package org.chiangmeng.qfast.database

import kotlin.Long
import kotlin.String

public data class LocalActiveQueueEntity(
  public val shop_id: String,
  public val ticket_number: Long,
  public val category: String,
  public val status: String,
  public val time: String,
  public val call_time: String?,
  public val pre_order: String?,
)
